import { useState } from 'react'

export const useCopy = (text: string, duration = 2000) => {
  const [copied, setCopied] = useState(false)

  const copy = () => {
    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), duration)
  }

  return { copied, copy }
}
